import React from "react";

const CloseIcon2 = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99996 2.29163C5.74276 2.29163 2.29163 5.74276 2.29163 9.99996C2.29163 14.2572 5.74276 17.7083 9.99996 17.7083C14.2572 17.7083 17.7083 14.2572 17.7083 9.99996C17.7083 5.74276 14.2572 2.29163 9.99996 2.29163ZM1.04163 9.99996C1.04163 5.05241 5.05241 1.04163 9.99996 1.04163C14.9475 1.04163 18.9583 5.05241 18.9583 9.99996C18.9583 14.9475 14.9475 18.9583 9.99996 18.9583C5.05241 18.9583 1.04163 14.9475 1.04163 9.99996ZM7.05802 7.05802C7.3021 6.81394 7.69782 6.81394 7.9419 7.05802L9.99996 9.11608L12.058 7.05802C12.3021 6.81394 12.6978 6.81394 12.9419 7.05802C13.186 7.3021 13.186 7.69782 12.9419 7.9419L10.8838 9.99996L12.9419 12.058C13.186 12.3021 13.186 12.6978 12.9419 12.9419C12.6978 13.186 12.3021 13.186 12.058 12.9419L9.99996 10.8838L7.9419 12.9419C7.69782 13.186 7.3021 13.186 7.05802 12.9419C6.81394 12.6978 6.81394 12.3021 7.05802 12.058L9.11608 9.99996L7.05802 7.9419C6.81394 7.69782 6.81394 7.3021 7.05802 7.05802Z"
        fill="#59566C"
      />
    </svg>
  );
};

export default CloseIcon2;
